
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.681 8.393L5.138 10H3.75l2.327-6.25h1.606L10 10H8.541l-.544-1.607H5.681zm2.043-.92l-.849-2.528h-.061l-.849 2.527h1.76-.001z"}}),_c('path',{attrs:{"d":"M0 2.5A2.5 2.5 0 012.5 0h8.75a2.5 2.5 0 012.5 2.5v3.75h3.75a2.5 2.5 0 012.5 2.5v8.75a2.5 2.5 0 01-2.5 2.5H8.75a2.5 2.5 0 01-2.5-2.5v-3.75H2.5a2.5 2.5 0 01-2.5-2.5V2.5zm2.5-1.25A1.25 1.25 0 001.25 2.5v8.75A1.25 1.25 0 002.5 12.5h8.75a1.25 1.25 0 001.25-1.25V2.5a1.25 1.25 0 00-1.25-1.25H2.5zm8.922 12.494c.242.376.503.729.788 1.057-.935.719-2.091 1.251-3.46 1.615.223.271.564.794.694 1.084 1.406-.449 2.6-1.055 3.607-1.867.972.83 2.174 1.456 3.663 1.84.166-.318.517-.842.786-1.113-1.406-.316-2.571-.867-3.525-1.605.851-.934 1.527-2.064 2.026-3.446H17.5V10h-3.75v1.309h.956c-.397 1.055-.925 1.932-1.59 2.662a7.587 7.587 0 01-.518-.615c-.353.226-.757.36-1.176.388z"}})])
          )
        }
      }
    